export default function addedToCart() {
    // The theme confirms an add with its own minipopup (here and on the product
    // cards in main.js); the shared JS skips its "Ürün sepete eklendi" toast so
    // the visitor doesn't get the same message twice.
    window.themeShowsAddedToCartPopup = true;

    window.$.subscribe('/product/added-to-cart', function (event, product_unique_id, basket_response) {
        const basket_product = basket_response.products.find(product => product.product.unique_id === product_unique_id);

        if (basket_product !== undefined){

            Riode.Minipopup.open({
                message: translates.product_added_to_cart,
                productClass: 'product-cart',
                name: basket_product.product.name,
                nameLink: basket_product.product.url,
                imageSrc: basket_product.product.image?.url,
                imageLink: basket_product.product.url,
                price: basket_product.total_readable,
                count: null,
                actionTemplate: `<div class="action-group d-flex">
            <a href="/basket" class="btn btn-sm btn-primary btn-rounded">${translates.complete_order}</a>
            </div>`
            })

        } else {

            // No basket line to show in the minipopup; still confirm the add,
            // since the shared toast is skipped on this theme.
            App.prototype.notificationSuccess(translates.product_added_to_cart);

        }

    });
}
